import { createMuiTheme } from '@/theme'
import { View } from '@react-pdf/renderer'

const BorderedItem = ({ item, theme, index }) => (
  <View
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      // eslint-disable-next-line no-nested-ternary
      backgroundColor: index === 0 ? '#c9d8ef' : index === 1 ? '#e8ecf2' : 'white',
      borderTop: index !== 0 ? `1px solid ${theme.palette.secondary_120.main}` : 'none',
      padding: 5,
    }}
  >
    {item}
  </View>
)

const PDFBorderedList2 = ({ name, items = [], style, ...props }) => {
  const theme = createMuiTheme({})
  return (
    <View
      style={{
        border: `1.5px solid ${theme.palette.secondary_120.main}`,
        textAlign: 'left',
        ...style,
      }}
      {...props}
    >
      {items.map((item, index) => (
        <BorderedItem
          key={`${name}_borderedlist_item_${index + 1}`}
          item={item}
          theme={theme}
          index={index}
        />
      ))}
    </View>
  )
}

export default PDFBorderedList2
